import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './PopUp.scss';

class PopUp extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        isError: PropTypes.bool,
        dataQa: PropTypes.string,
    };

    static defaultProps = {
        isError: false,
        dataQa: 'pop-up',
    };


    componentDidMount() {
        document.body.classList.add('no-scroll');
    }

    componentWillUnmount() {
        document.body.classList.remove('no-scroll');
    }

    render() {
        const {children, isError, dataQa} = this.props;
        return (
            <div className={classNames('ace-c-pop-up', {'ace-is-error': isError})} data-qa={dataQa}>
                <div className="ace-c-pop-up__wrapper">
                    <div className="ace-grid__row ace-c-pop-up__background-wrapper">
                        <div className="col-start-xs--2 col-xs--10 ace-c-pop-up__background-container" />
                    </div>
                    <div className="ace-grid__row ace-c-pop-up__content-container">
                        {children}
                    </div>
                </div>
            </div>
        );
    }
}

export default PopUp;
